


















































































































import moment from "moment";
import _ from "lodash";
import Vue from "vue";
import { captcha, sendVerifyCode, checkPhone, resetPassword } from "@/api/registry";
import { Validators, ValidatorError } from "@/scripts/validator";
import { Toast } from "vant";
import config from "@/config";
import { throttle } from "@/scripts/throttle";

let timer: NodeJS.Timeout | null = null;

export default Vue.extend({
    name: "ResetPassword",
    data() {
        const passwordValidator = (field: string, message: string): Promise<ValidatorError> => {
            if (
                !_.isEmpty(this["form"].password) &&
                !_.isEmpty(this["form"].confirmPassword) &&
                this["form"].password !== this["form"].confirmPassword
            ) {
                return Promise.reject({
                    valid: false,
                    field: field,
                    message: message
                });
            }
            return Promise.resolve({
                valid: true,
                field: field,
                message: ""
            });
        };
        return {
            step: 1,
            showDialog: false,
            view: {
                password: { icon: "eye-close", type: "password" },
                confirmPassword: { icon: "eye-close", type: "password" }
            },
            count: 0,
            logo: config.LOGIN_LOGO_URL,
            iconPrefix: this.$constants.CUSTOM_ICON_PREFIX,
            captcha: {
                sign: "",
                base64: "",
                expires: 0
            },
            form: {
                phone: "",
                captcha: "",
                verifyCode: "",
                password: "",
                confirmPassword: ""
            },
            validator: Validators({
                phone: [
                    { is: "required", message: this.$t("registry.error.phone_required") },
                    { is: "phone", message: this.$t("registry.error.phone_mismatch") }
                ],
                captcha: [
                    {
                        is: "required",
                        message: this.$t("registry.error.captcha_required")
                    }
                ],
                verifyCode: [
                    {
                        is: "required",
                        message: this.$t("registry.error.verify_code_required")
                    }
                ],
                password: [
                    {
                        is: "simplePassword",
                        message: this.$t("registry.error.password_mismatch")
                    }
                ],
                confirmPassword: [
                    {
                        is: "simplePassword",
                        message: this.$t("registry.error.password_mismatch")
                    },
                    {
                        is: passwordValidator,
                        message: this.$t("registry.error.password_confirm_error")
                    }
                ]
            })
        };
    },
    computed: {
        title(): string {
            return this.step === 1
                ? (this.$t("resetPassword.title1") as string)
                : (this.$t("resetPassword.title2") as string);
        },
        verifyCodeBtnText(): string {
            return this.count < 1
                ? (this.$t("registry.get_verify_code") as string)
                : (this.$t("registry.retry_verify_code", [this.count]) as string);
        },
        verifyCodeBtnDisabled(): boolean {
            return !(this.form.phone && this.form.captcha);
        },
        checkDisabled(): boolean {
            return !this.form.phone;
        },
        submitDisabled(): boolean {
            return !(
                this.form.phone &&
                this.form.captcha &&
                this.form.verifyCode &&
                this.form.password &&
                this.form.confirmPassword
            );
        }
    },
    mounted() {
        this.loadCaptcha();
        this.startCounter();
    },
    methods: {
        checkPhone() {
            throttle.wait().do(() => {
                this.validator
                    .validates(this.form, ["phone"])
                    .then(() => checkPhone(this.form.phone))
                    .then(() => {
                        this.step = 2;
                    })
                    .catch(errors => {
                        this.validator.setErrors(errors, "phone");
                    });
            });
        },
        onPhoneChange() {
            this.validator.emit("phone", this.form.phone);
            if (!_.isEmpty(this.form.verifyCode)) {
                this.form.verifyCode = "";
                this.loadCaptcha(false);
            }
        },
        eyeToggle(field: string) {
            this.view[field] =
                this.view[field].icon === "eye-close"
                    ? { icon: "eye-open", type: "text" }
                    : { icon: "eye-close", type: "password" };
        },
        startCounter(restart = false): void {
            if (0 < this.count && this.count < this.$constants.COUNTDOWN_MAX) return;
            let lastTime = moment(localStorage.getItem(this.$constants.COUNTDOWN_LOCAL_STORAGE_KEY));
            if (!lastTime.isValid()) {
                if (!restart) return;
                lastTime = moment();
                localStorage.setItem(this.$constants.COUNTDOWN_LOCAL_STORAGE_KEY, lastTime.format());
            }
            this.count = this.$constants.COUNTDOWN_MAX - moment().diff(lastTime, "seconds") - 1;
            timer = setInterval(() => {
                if (--this.count < 1) {
                    localStorage.removeItem(this.$constants.COUNTDOWN_LOCAL_STORAGE_KEY);
                    timer && clearInterval(timer);
                    return;
                }
            }, 1000);
        },
        loadCaptcha(reset = true) {
            reset && (this.form.captcha = "");
            captcha().then(captcha => {
                this.captcha = captcha;
            });
        },
        sendVerifyCode() {
            throttle.wait().do(() => {
                if (0 < this.count && this.count < this.$constants.COUNTDOWN_MAX) return;
                this.validator
                    .validates(this.form, ["phone", "captcha"])
                    .then(() =>
                        sendVerifyCode(this.form.phone, this.form.captcha, this.captcha.sign, this.captcha.expires)
                    )
                    .then(() => {
                        this.startCounter(true);
                        Toast(this.$t("common.alert.captcha_alert"));
                    })
                    .catch(errors => {
                        this.loadCaptcha();
                        this.validator.setErrors(errors, "phone");
                    });
            });
        },
        onSubmit() {
            throttle.wait().do(() => {
                this.validator
                    .validates(this.form)
                    .then(() =>
                        resetPassword(
                            this.form.phone,
                            this.form.verifyCode,
                            this.form.password,
                            this.form.confirmPassword
                        )
                    )
                    .then(() => {
                        this.showDialog = true;
                    })
                    .catch(errors => {
                        this.loadCaptcha(false);
                        this.validator.setErrors(errors, "phone");
                    });
            });
        }
    },
    destroyed() {
        if (timer) {
            clearInterval(timer);
        }
    }
});
